export const labels = {
	addMorePhotos: {
		label: "Label.MobileCreator.PhotoSelection.AddMore",
		default: "Add more",
		// description: "Text displayed below icon. Triggers a dialog to add more photos to the current photo selection."
	},
	emptyPhotoSelection: {
		label: "Label.MobileCreator.PhotoSelection.Empty",
		default: "No photos added yet",
		// description: "No photos added yet"
	},
	tapToAddMorePhotos: {
		label: "Label.MobileCreator.PhotoSelection.TapToAddMore",
		default: "Tap here to start adding your photos",
	},
} as const;
